import { Select } from '@chakra-ui/react'
import { useEffect, useState } from 'react'
import { TooltipCell } from '../ToolTipCell'
import { UncontrolledSelect } from '@/components/UncontrolledForm'

const SelectCell = ({
  getValue,
  row: { index },
  column: { id },
  table,
  options,
  extraDisable = false,
  searchable = false,
}) => {
  const initialValue = getValue()
  const [localValue, setLocalValue] = useState(initialValue)
  const isDisabled = table.options.meta?.disabled || extraDisable

  useEffect(() => {
    setLocalValue(initialValue)
  }, [initialValue])

  const onChange = (e) => {
    const newValue = e.target.value || ''

    setLocalValue(newValue)

    //React-table v8 will replace . with _
    table.options.meta?.updateData(index, id.replace('__', '._'), newValue)
  }

  const onChangeForSearchable = (selectedOption) => {
    const newValue = selectedOption ? selectedOption.value : ''

    setLocalValue(newValue)

    //React-table v8 will replace . with _
    table.options.meta?.updateData(index, id.replace('__', '._'), newValue)
  }

  if (isDisabled) {
    const selectedOption = options?.find((option) => option.value === localValue)
    return <TooltipCell text={selectedOption?.label ?? localValue ?? '(empty)'} />
  }

  if (searchable) {
    return (
      <UncontrolledSelect
        value={localValue}
        onChange={onChangeForSearchable}
        options={options || []}
        isMulti={false}
        width={'100%'}
      />
    )
  }

  return (
    <Select value={localValue} onChange={onChange} placeholder="(empty)" isDisabled={isDisabled}>
      {options &&
        options.map((option) => (
          <option key={option.value} value={option.value}>
            {option.label}
          </option>
        ))}
    </Select>
  )
}

export default SelectCell
